<template>
  <el-select 
    class="AGlassChamferSelector inline" 
    v-model="val" 
    size="mini"
    @change="change">
    <el-option 
      v-for="item in items" 
      :key="item.value" 
      :label="item.label" 
      :value="item.value" 
    />
  </el-select>
</template>
<script>
import { selector } from "@/common/mixins/selector";

export default {
  name: "AGlassChamferSelector",
  mixins: [selector],    
  computed: {
    items: function() {
      return this.system.options.glass_chamfer_type;
    }
  },
};
</script>
